import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import * as moment from 'moment';
import * as _ from 'lodash';
import { IBillingState, BillingActionCreators, IBillingListResponse, IApplicationState, AppActionCreators } from '@nkr/store/index';
import { ISortBy } from '@nkr/models/index';
import { Glyphicon } from 'react-bootstrap';
import ListRow from './list-row';
import { TableWrapper } from '../styles';
import NoData from '../no-data';

interface IOwnProps {
    centerId: number
}

interface IStateProps {
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getList: (centerId: number) => Promise<IBillingListResponse>,
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    sortBy: ISortBy[]
}

class Upcoming extends React.Component<TProps, IState> {
    readonly state: IState = {
        sortBy: []
    }

    componentWillMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting upcoming swaps, one moment please...').then(() => {
            this.props.getList(this.props.centerId).then(() => {
                this.props.hideLoading();
            });
        });
    }

    getSortedRows = () => {
        let rows = this.props.billing.upcoming;
        let sortByProperties = this.state.sortBy.map((sortBy) => sortBy.property);
        let sortByDirections = this.state.sortBy.map((sortBy) => sortBy.direction);

        let sortedRows = this.state.sortBy.length > 0 ? _.orderBy(rows, (item) => {
            return sortByProperties.map(sortBy => {
                if (sortBy == 'billableNephrectomy.transplantDate')
                    return moment(item.billableNephrectomy.transplantDate).format('YYYYMMDD');

                if (sortBy = 'donorCenter')
                    return item.billableNephrectomy.donor.rdnCenterId > 0 ? ' ' + item.billableNephrectomy.donor.center.alias + ' (' + item.billableNephrectomy.donor.rdnCenterAlias + ')' : item.billableNephrectomy.donor.center.alias;

                return item[sortBy];
            });
        }, sortByDirections) : rows;

        return sortedRows;
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);
        let sort = sortBy.find(item => item.property == property);

        if (sort != null) {
            if (sort.direction == 'asc')
                sort.direction = 'desc'
            else
                if (sort.direction == 'desc')
                    sortBy = sortBy.filter(item => item.property != property);
        } else {
            sortBy.push({ property, direction: 'asc' });
        }

        this.setState({
            sortBy
        });
    }

    renderHeaderSort = (property: string) => {
        let sortItem = this.state.sortBy.find(item => item.property == property);

        if (sortItem != null) {
            return <Glyphicon glyph={sortItem.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const sortedRows = this.getSortedRows();

        return (
            <>
                <div style={{ marginTop: 0 }}>
                    {sortedRows.length > 0 ?
                        <div style={{ border: '1px solid #ddd', padding: '1%', marginLeft: '1%', marginRight: '1%', borderRadius: 4 }}>
                            <TableWrapper striped>
                                <thead>
                                    <tr>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('billableNephrectomy.transplantDate')}>Surgery Date {this.renderHeaderSort('billableNephrectomy.transplantDate')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('swapNumber')}>Swap # {this.renderHeaderSort('swapNumber')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenter')}>Donor Center {this.renderHeaderSort('donorCenter')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('billableNephrectomy.donor.alias')}>Donor Alias {this.renderHeaderSort('billableNephrectomy.donor.alias')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('billableNephrectomy.recipient.center.alias')}>Recipient Center {this.renderHeaderSort('billableNephrectomy.recipient.center.alias')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('billableNephrectomy.recipient.alias')}>Recipient Alias {this.renderHeaderSort('billableNephrectomy.recipient.alias')}</th>
                                        <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('claimType')}>Claim Type {this.renderHeaderSort('claimType')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedRows.map((item, index) =>
                                        <ListRow
                                            key={index}
                                            data={item}
                                        />
                                    )}
                                </tbody>
                            </TableWrapper>
                        </div>
                        :
                        <NoData message='No upcoming swaps...' />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getList: (centerId) => { return dispatch(BillingActionCreators.getUpcomingList(centerId)); },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Upcoming);